import React, { Component } from "react";
import EditInfoFieldDialog from "../../components/teams/EditInfoFieldDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import moment from "moment-timezone";

class EditInfoFieldContainer extends Component {
  state = {
    open: false,
    name: "",
    submitDisabled: true,
    showOnLive: false,
    lang: "0",
    trs: {},
  };

  handleTrsNameChange = (event) => {
    let trs = this.state.trs;
    trs[this.state.lang] = event.target.value;

    this.setState({ trs: trs });
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  UNSAFE_componentWillMount = () => {
    const infoField = this.props.infoField;
    if (infoField) {
      this.updateState(infoField);
    }
  };

  updateState = (infoField) => {
    this.setState({
      name: infoField.name || "",
      showOnLive: infoField.showOnLive || false,
      trs: infoField.trs || {},
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "name") {
      if (event.target.value.length > 0) {
        newState["submitDisabled"] = false;
      } else {
        newState["submitDisabled"] = true;
      }
    } else if (this.props.infoField) {
      newState["submitDisabled"] = false;
    }
    this.setState(newState);
  };

  handleShowOnLiveCheck = (event) => {
    const checked = event.target.checked;
    this.setState({ showOnLive: checked, submitDisabled: false });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });

    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let newInfoFields = this.props.tournament.infoFields || {};
    if (this.props.refereesPage) {
      newInfoFields = this.props.tournament.infoFieldsReferees || {};
    } else if (this.props.playersPage) {
      newInfoFields = this.props.tournament.infoFieldsPlayers || {};
    }
    let infoFieldId = moment().unix().toString();
    if (this.props.infoField) {
      infoFieldId = this.props.infoField.id;
      if (newInfoFields[this.props.infoField.id] === undefined) {
        newInfoFields[this.props.infoField.id] = {};
      }
      newInfoFields[this.props.infoField.id]["name"] = this.state.name;
      newInfoFields[this.props.infoField.id]["showOnLive"] =
        this.state.showOnLive;
      newInfoFields[this.props.infoField.id]["trs"] = this.state.trs;
    } else {
      newInfoFields[infoFieldId] = {};
      newInfoFields[infoFieldId]["name"] = this.state.name;
      newInfoFields[infoFieldId]["showOnLive"] = this.state.showOnLive;
      newInfoFields[infoFieldId]["trs"] = this.state.trs;
      newInfoFields[infoFieldId]["show"] = true;
      newInfoFields[infoFieldId]["signup"] = true;
    }

    let toUpdate = {};
    if (this.props.refereesPage) {
      toUpdate["infoFieldsReferees"] = newInfoFields;
    } else if (this.props.playersPage) {
      toUpdate["infoFieldsPlayers"] = newInfoFields;
    } else {
      toUpdate["infoFields"] = newInfoFields;
    }

    tournamentRef
      .update(toUpdate)
      .then(() => {
        if (this.props.infoField) {
          this.setState({ submitDisabled: true });
        } else {
          if (window.firebase.analytics) {
            window.firebase.analytics().logEvent("infofield_added");
          }
          this.setState({
            submitDisabled: true,
            name: "",
            trs: {},
            lang: "0",
          });
        }

        if (!this.props.refereesPage && !this.props.playersPage) {
          const batch = window.firebase.firestore().batch();
          tournamentRef
            .collection("teams")
            .get()
            .then((snap) => {
              snap.forEach((tSnap) => {
                const toUpdate = {};
                if (this.state.showOnLive) {
                  toUpdate[infoFieldId] =
                    (this.props.teamsContactInfo[tSnap.id] || {})[
                      infoFieldId
                    ] || "";
                } else {
                  toUpdate[infoFieldId] = "";
                }
                batch.update(
                  tournamentRef.collection("teams").doc(tSnap.id),
                  toUpdate
                );
              });
              batch.commit().then(() => {
                this.toggleDialog();
              });
            });
        } else if (this.props.playersPage) {
          const batch = window.firebase.firestore().batch();
          tournamentRef
            .collection("players")
            .get()
            .then((snap) => {
              snap.forEach((tSnap) => {
                const toUpdate = (tSnap.data() || {}).infoFields || {};
                if (this.state.showOnLive) {
                  toUpdate[infoFieldId] =
                    (this.props.playersContactInfo[tSnap.id] || {})[
                      infoFieldId
                    ] || "";
                } else {
                  toUpdate[infoFieldId] = "";
                }
                batch.update(
                  tournamentRef.collection("players").doc(tSnap.id),
                  { infoFields: toUpdate }
                );
              });
              batch.commit().then(() => {
                this.toggleDialog();
              });
            });
        } else {
          this.toggleDialog();
        }
      })
      .catch((error) => {
        this.setState({ submitDisabled: false });
      });
  };
  render() {
    return (
      <div>
        {this.props.infoField ? (
          <IconButton
            aria-label="Change"
            onClick={this.toggleDialog}
            disabled={this.props.disabled}
            style={{ height: 30, width: 30 }}
          >
            <CreateIcon
              style={{ height: 20, width: 20, position: "absolute", top: 5 }}
            />
          </IconButton>
        ) : (
          <Button
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
            style={{ marginTop: -15 }}
          >
            {languages.teamInfo.addInfoField}
          </Button>
        )}
        <EditInfoFieldDialog
          name={
            this.state.lang !== "0"
              ? this.state.trs[this.state.lang] || ""
              : this.state.name
          }
          showOnLive={this.state.showOnLive}
          handleShowOnLiveCheck={this.handleShowOnLiveCheck}
          submitDisabled={this.state.submitDisabled}
          open={this.state.open}
          infoField={this.props.infoField}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          refereesPage={this.props.refereesPage}
          tournament={this.props.tournament}
          playersPage={this.props.playersPage}
          lang={this.state.lang}
          handleTrsNameChange={this.handleTrsNameChange}
        />
      </div>
    );
  }
}

export default EditInfoFieldContainer;
